import {useState,useEffect} from 'react';
import {useDisclosure, FormControl,FormLabel, Radio,RadioGroup, HStack,  Flex, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody} from '@chakra-ui/react'
import OsobaView from './OsobaView';
import OsobaStranaView from './OsobaStranaView';

const OsobaControl = ({vrstaosobe,osoba, readonly, onCloseControl, onSave,size='xs'}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [vrosobe, setVrosobe] = useState(vrstaosobe);
    useEffect(() => {
        onOpen();
    }, []);
    const Close=(e)=>{
        onCloseControl();
        onClose();
    }

    const PrikaziOsobu=()=>{
        if (vrstaosobe==="fizicka" || vrstaosobe==="pravna") {
            return (<OsobaView vrstaosobe={vrosobe} osoba={osoba} readonly={readonly} onCancel={Close} onSave={onSave}/>)
        } else if (vrstaosobe==="stranapravna") {
            return (<OsobaStranaView vrstaosobe={vrosobe} stranaosoba={osoba} readonly={readonly} onCancel={Close} onSave={onSave}/>)
        }
        
    }

    const PrikaziFizickaPravna=()=>{
        if (vrstaosobe==='fizicka' || vrstaosobe==='pravna') {
            return (
                <FormControl as={'fieldset'}  mb={'0.3rem'} disabled={readonly}>
                    <FormLabel fontSize={size} as='legend'>Vrsta osobe</FormLabel>
                        <RadioGroup defaultValue={vrstaosobe} mb={'1rem'} size={'sm'} fontSize={size} colorScheme='grunt2'>
                            <HStack spacing={'2rem'}>
                                <Radio id={'rbf'} value='fizicka' onChange={()=>setVrosobe('fizicka')}>Fizička</Radio>
                                <Radio id={'rbp'} value='pravna' onChange={()=>setVrosobe('pravna')}>Pravna</Radio>
                            </HStack>
                        </RadioGroup>
                </FormControl>
            )
        }
    }

    return (
        <Drawer placement='right' size={'xl'} onClose={Close} isOpen={isOpen}>
             <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Partner
                    </DrawerHeader>
                    <DrawerBody>
                        <Flex direction={'column'} scrollBehavior={'auto'}>
                            {PrikaziFizickaPravna()}
                            {PrikaziOsobu()}
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
        </Drawer>
        
            
        
    );
}

export default OsobaControl;
